<template> 
  <v-app>
    <notification></notification>
    <router-view />
  </v-app>
</template>

<script>
import Notification from '@/components/layout/Notification';

export default {
  components: { Notification }
};
</script>
